import { render } from "./KP_SELECT.vue?vue&type=template&id=6cb7e6f0&ts=true"
import script from "./KP_SELECT.vue?vue&type=script&lang=ts"
export * from "./KP_SELECT.vue?vue&type=script&lang=ts"

import "./KP_SELECT.vue?vue&type=style&index=0&id=6cb7e6f0&lang=less"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__